export const TYPE_HYBRID = 'hybrid';
export const TYPE_ONLINE = 'online';
export const TYPE_OFFLINE = 'offline';
export const TYPE_HIDDEN = 'hidden';

export const EPISODE_STATUSES = {
    idle: 'idle',
    live: 'live',
    record: 'record',
};
export const THEME_DARK = 'dark';
export const THEME_LIGHT = 'light';

export const FULLSCREEN_MODES = {
    CHAT: "chat",
    VIDEO: "video",
}

export const STREAM_STATUSES = {
    STOPPED: "stopped",
    PAUSED: "paused",
    FLOATING: "floating",
    WAITING: "waiting",
    STARTING: "starting",
    INTERRUPTED: "interrupted",
}

export const RECORD_STATUSES = {
    RECORD: "record",
    RECORD_CUT: "recordCut",
    EPISODES_CUT: "episodesCut",
}

export const LANGUAGE = 'lang';
export const LANG_RU = 'ru';
export const LANG_EN = 'en';

export const AVAILABLE_LOCALES = [LANG_RU, LANG_EN];

export const ARCHIVE_STATUSES = {
    DONE: 'done',
    FILE: 'file',
    NONE: 'none',
}
export const CUT_STATUSES = [ARCHIVE_STATUSES.DONE, ARCHIVE_STATUSES.FILE];

export const ERROR_MESSAGE = {
    CLIENT_IS_BANNED: 'Client is banned',
};

export const TEST_EMAIL = 'test@comdi.com';

export const DEFAULT_MESSAGES_MODEL = { messages: null, hasMore: false, lastScrollData: { scrollTop: 0, offset: 0 }, scrollAtStart: true };
